export const INIT_APPLICATION = '@@app/INIT_APPLICATION';

export const FETCH_SETTING = '@@app/FETCH_SETTING';
export const FETCH_SETTING_SUCCESS = '@@app/FETCH_SETTING_SUCCESS';
export const FETCH_SETTING_ERROR = '@@app/FETCH_SETTING_ERROR';

export const FETCH_APP_MENU = '@@app/FETCH_APP_MENU';
export const FETCH_APP_MENU_SUCCESS = '@@app/FETCH_APP_MENU_SUCCESS';
export const FETCH_APP_MENU_ERROR = '@@app/FETCH_APP_MENU_ERROR';

export const FETCH_CUSTOM_PAGE = '@@app/FETCH_CUSTOM_PAGE';
export const FETCH_CUSTOM_PAGE_SUCCESS = '@@app/FETCH_CUSTOM_PAGE_SUCCESS';
export const FETCH_CUSTOM_PAGE_ERROR = '@@app/FETCH_CUSTOM_PAGE_ERROR';

export const SET_PAGE_META = '@@app/SET_PAGE_META';
export const TOGGLE_SIDENAV = '@@app/TOGGLE_SIDENAV';
